import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiStatements extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}